export const decodeLookup = (raw: unknown): { id: string; label?: string } | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const { id, label } = raw as { id?: unknown; label?: unknown };

  if (typeof id !== 'string' || !id) {
    return null;
  }

  return { id, label: typeof label === 'string' ? label : undefined };
};
